<template>
  <div>
    <b-nav-item-dropdown class="dropdown-notification mr-75"
      menu-class="dropdown-menu-media dropdown-menu-right mi-menu-progreso" left
      v-b-tooltip.hover.button.viewport="`${$t('dmp.templates')}`">
      <template #button-content>
        <feather-icon :badge="activeCount" badge-classes="bg-danger" class="text-body" icon="LayersIcon" size="21" />
      </template>

      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex justify-content-between align-items-center py-2 px-2 border-bottom">
          <h4 class="notification-title mb-0 font-weight-bold text-dark">
            {{ $t("dmp.inProgress") }}
          </h4>
          <b-badge pill variant="light-primary">
            {{ activeCount }}
          </b-badge>
        </div>
      </li>

      <div class="notif-scroll-container">

        <li v-for="job in filteredNotifications" :key="job.panelId"
          class="border-bottom p-2 list-unstyled bg-light-section">
          <div class="d-flex justify-content-between align-items-center mb-50">
            <span class="font-weight-bold text-dark text-truncate" style="max-width: 60%; font-size: 13px;">
              {{ job.templateName }}
            </span>
            <div class="d-flex align-items-center" style="gap: 0.5rem;">
              <span class="small font-weight-bold"
                :class="job.isJobError ? 'text-danger' : (job.isDone ? 'text-success' : 'text-primary')">
                {{ job.progress }}%
              </span>
              <button class="btn btn-xs p-0" @click="job.isOpen = !job.isOpen">
                <feather-icon :icon="job.isOpen ? 'ChevronDownIcon' : 'ChevronUpIcon'" size="14" />
              </button>
              <button class="btn btn-xs p-0" @click="removeJob(job.panelId)">
                <feather-icon icon="XIcon" size="14" />
              </button>
            </div>
          </div>

          <b-progress :value="job.progress" :max="100"
            :variant="job.isJobError ? 'danger' : (job.isDone ? 'success' : 'primary')" animated height="6px"
            class="my-50" />

          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted font-weight-bold" style="font-size: 11px;">
              {{ getSummaryLabel(job) }}
            </small>
          </div>

          <div v-show="job.isOpen" class="border-top mt-1 bg-white rounded" style=" overflow-y:auto;">
            <div v-if="job.isJobError">
              <div v-if="job.failedStep" class="py-50">
                <div class="d-flex align-items-center">
                  <div
                    class="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 bg-danger text-white mr-1"
                    style="width:16px; height:16px;">
                    <feather-icon icon="XIcon" size="10" />
                  </div>

                  <span class="text-danger font-weight-bold text-uppercase" style="font-size:12px;">
                    {{ job.failedStep.name.replace(/_/g, ' ') }} - {{ $t("dmp.templateConfig.errorStep") }}
                  </span>
                </div>

                <div v-if="job.failedStep.params" class="pt-1">
                  <template v-if="getStepParams(job.failedStep)">
                    <div v-for="item in getStepParams(job.failedStep)" :key="item.key"
                      class=" d-flex align-items-start pt-1">


                      <div
                        class="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 bg-white text-dark mr-1 border border-dark"
                        style="width:16px; height:16px;">
                        <feather-icon icon="ArrowRightIcon" size="10" />
                      </div>

                      <small v-if="item.key" class="font-weight-bold text-dark mr-50">{{ item.key }}:</small>
                      <small class="font-weight-bold text-dark mr-50">{{ item.value }}</small>
                    </div>
                  </template>
                  <small v-else class="text-muted">{{ job.failedStep.message }}</small>
                </div>

                <small v-else class="text-muted">{{ job.failedStep.message }}</small>
                <p class="text-danger small mt-4" style="font-size:11px;">
                  {{ $t("dmp.templateConfig.tryAgain") }}
                </p>
              </div>
            </div>

            <template v-else>
              <div v-for="step in job.steps" :key="step.name"
                class="d-flex align-items-center px-2 py-50 border-bottom">
                <div class="rounded-circle d-flex align-items-center justify-content-center mr-1 flex-shrink-0" :class="{
                  'text-gray border': step.status === 'waiting',
                  'bg-info text-white': step.status === 'processing',
                  'bg-success text-white': step.status === 'success',
                  'bg-danger text-white': step.status === 'error',
                }" style="width:16px; height:16px;">
                  <b-spinner v-if="step.status === 'processing'" style="width:8px;height:8px" />
                  <feather-icon v-else-if="step.status === 'success'" icon="CheckIcon" size="8" />
                  <feather-icon v-else-if="step.status === 'error'" icon="XIcon" size="8" />
                  <feather-icon v-else icon="ClockIcon" size="8" />
                </div>

                <span class="text-uppercase flex-grow-1" style="font-size:10px;" :class="{
                  'text-muted': step.status === 'waiting',
                  'text-primary font-weight-bold': step.status === 'processing',
                  'text-dark': step.status === 'success',
                  'text-danger': step.status === 'error',
                }">
                  {{ step.name.replace(/_/g, ' ') }}
                </span>

                <small v-if="step.message" class="text-danger ml-1" style="font-size:9px;">{{ step.message }}</small>
              </div>
            </template>
          </div>

        </li>
      </div>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import { BNavItemDropdown, BBadge, BProgress, BSpinner } from "bootstrap-vue";
import { ref, computed, getCurrentInstance, onMounted, onUnmounted } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "DmpTemplateNotification",
  components: {
    BNavItemDropdown,
    BBadge,
    BProgress,
    BSpinner,
  },
  setup() {
    const STORAGE_KEY = 'active_processes'
    const { proxy } = getCurrentInstance();
    const filteredNotifications = ref([]);

    const saveToStorage = () => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(
        filteredNotifications.value.map(n => ({
          userId: n.userId,
          panelId: n.panelId,
          templateId: n.templateId,
          templateName: n.templateName,
          isDone: n.isDone,
          isJobError: n.isJobError,
          failedStep: n.failedStep,
          progress: n.progress,
          total: n.total,
          steps: n.steps,
        }))
      ))
    }

    const ALL_STEPS = [
      'COMMUNICATION_PATH', 'NETWORK_OPTIONS', 'DEVICE_SETUP', 'CARD_FORMAT',
      'REMOTE_OPTIONS', 'SYSTEM_REPORTS', 'SYSTEM_OPTIONS', 'BELL_OPTIONS',
      'OUTPUT_OPTIONS', 'OUTPUT_INFORMATION', 'OUTPUT_GROUPS', 'MENU_DISPLAY',
      'STATUS_LIST', 'PC_LOG_REPORTS', 'GLOBAL_AREA_CONFIG', 'AREA_INFORMATION',
      'ZONE_INFORMATION', 'HOLIDAY_DATES', 'TIME_SCHEDULES', 'AREA_SCHEDULES',
      'PROFILES', 'USER_CODES'
    ];

    const activeCount = computed(() => {
      return filteredNotifications.value.filter(n => !n.isDone).length;
    });

    const getSummaryLabel = (job) => {
      if (job.isDone && !job.isJobError) {
        return proxy.$t("dmp.templateConfig.appliedSuccess");
      } else if (job.isJobError) {
        return proxy.$t("dmp.templateConfig.errorApplying");
      }
      const current = job.steps.filter(s => s.status !== 'waiting').length;
      return proxy.$t("dmp.templateConfig.step") + ` ${current} / ${job.total}`;
    };

    const startJobTracking = ({ userId, panelId, templateId, templateName }) => {
      if (filteredNotifications.value.some(n => n.panelId === panelId)) return;
      const newJob = {
        panelId,
        templateId,
        templateName,
        userId,
        progress: 0,
        isDone: false,
        isOpen: false,
        isJobError: false,
        failedStep: null,
        total: 0,
        steps: ALL_STEPS.map(name => ({
          name,
          status: 'waiting',
          message: null,
        }))
      };

      filteredNotifications.value.unshift(newJob);
      saveToStorage()

      window.Echo
        .private(`template-progress-${userId}-${panelId}`)
        .listen('.step.processed', (event) => {
          if (event.panel_id !== panelId || event.template_id !== templateId) return;

          const job = filteredNotifications.value.find(n => n.panelId === panelId);
          if (!job) return;

          if (event.step === 'JOB_FAILED') {
            job.isJobError = true;
            job.isDone = true;
            saveToStorage()
            proxy.$root.$emit('panel-template-done', { panelId });
            setTimeout(() => {
              window.Echo.leave(`template-progress-${userId}-${panelId}`);
            }, 2000);
            return;
          }

          job.total = event.total;
          job.progress = Math.round((event.current / event.total) * 100);

          if (event.completed_steps) {
            job.steps = job.steps.map(s => ({
              ...s,
              status: event.completed_steps[s.name] ?? s.status,
            }))
          }

          const existingStep = job.steps.find(s => s.name === event.step);
          if (existingStep) {
            existingStep.status = event.status;
            existingStep.message = event.message;
          }

          if (event.status === 'error') {
            const parsed = parseStepMessage(existingStep.message);
            job.failedStep = {
              name: existingStep.name,
              status: existingStep.status,
              message: event.message ?? parsed.message,
              params: event.params ?? parsed.params,
            }
            saveToStorage()
          }

          saveToStorage()

          if (event.current === event.total && event.status !== 'processing') {
            job.isDone = true;
            saveToStorage()
            proxy.$root.$emit('panel-template-done', { panelId });
            setTimeout(() => {
              window.Echo.leave(`template-progress-${userId}-${panelId}`);
            }, 2000);
          }
        });
    };

    const removeJob = (panelId) => {
      filteredNotifications.value = filteredNotifications.value.filter(n => n.panelId !== panelId);
      saveToStorage()
    };

    onMounted(() => {
      proxy.$root.$on('dmp-template-started', startJobTracking);
      try {
        const saved = localStorage.getItem(STORAGE_KEY)
        if (saved) {
          const processes = JSON.parse(saved)

          processes
            .filter(p => p.isDone)
            .forEach(p => {
              filteredNotifications.value.unshift({
                ...p,
                isOpen: false,
                isJobError: p.isJobError ?? false,
                failedStep: p.failedStep ?? null,
              })
            })

          processes
            .filter(p => !p.isDone)
            .forEach(p => startJobTracking(p))
        }
      } catch {
        localStorage.removeItem(STORAGE_KEY)
      }
    });

    onUnmounted(() => {
      proxy.$root.$off('dmp-template-started', startJobTracking);
    });

    const STEP_LABELS = {
      COMMUNICATION_PATH: (key) => `Comm Path #${key}`,
      NETWORK_OPTIONS: (key) => `Network Option: ${key}`,
      DEVICE_SETUP: (key) => `Device #${key}`,
      CARD_FORMAT: (key) => `Card Format #${key}`,
      REMOTE_OPTIONS: (key) => `Remote Option: ${key}`,
      SYSTEM_REPORTS: (key) => `System Report: ${key}`,
      SYSTEM_OPTIONS: (key) => `System Option: ${key}`,
      BELL_OPTIONS: (key) => `Bell Option: ${key}`,
      OUTPUT_OPTIONS: (key) => `Output Option: ${key}`,
      OUTPUT_INFORMATION: (key) => `Output #${key}`,
      OUTPUT_GROUPS: (key) => `Output Group #${key}`,
      MENU_DISPLAY: (key) => `Menu Display: ${key}`,
      STATUS_LIST: (key) => `Status: ${key}`,
      PC_LOG_REPORTS: (key) => `PC Log: ${key}`,
      GLOBAL_AREA_CONFIG: (key) => `Global Area Config: ${key}`,
      AREA_INFORMATION: (key) => `Area #${key}`,
      ZONE_INFORMATION: (key) => `Zone #${key}`,
      HOLIDAY_DATES: (key) => `Holiday #${key}`,
      TIME_SCHEDULES: (key) => `Time Schedule #${key}`,
      AREA_SCHEDULES: (key) => `Area Schedule #${key}`,
      PROFILES: (key) => `Profile #${key}`,
      USER_CODES: (key) => `User #${key}`,
    };

    const OBJECT_STEPS = new Set([
      'NETWORK_OPTIONS', 'SYSTEM_REPORTS', 'SYSTEM_OPTIONS', 'BELL_OPTIONS',
      'OUTPUT_OPTIONS', 'MENU_DISPLAY', 'STATUS_LIST', 'PC_LOG_REPORTS',
      'GLOBAL_AREA_CONFIG'
    ]);

    const getStepParams = (failedStep) => {
      if (!failedStep?.params) return null;

      let params = failedStep.params;

      if (typeof params === 'string') {
        try {
          params = JSON.parse(params);
        } catch {
          return [{ key: 'error', value: params }];
        }
      }

      const isObjectStep = OBJECT_STEPS.has(failedStep.name);
      const labelFn = STEP_LABELS[failedStep.name] ?? ((key) => key);

      if (typeof params === 'object' && !Array.isArray(params)) {
        return Object.entries(params).map(([key, value]) => ({
          key: isObjectStep ? 'Field' : labelFn(key), 
          value: cleanError(value),
        }));
      }

      return null;
    };

    const cleanError = (value) => {
      return value
        .replace(/^bad_request:\s*/i, '')
        .replace(/^internal_service:\s*/i, '');

    };

    const parseStepMessage = (message) => {
      if (!message) return { message: null, params: null };

      try {
        const decoded = JSON.parse(message);
        if (decoded?.data) {
          return {
            message: decoded.data.message ?? message,
            params: decoded.data.parms ?? null,
          };
        }
      } catch {
      }

      return { message, params: null };
    };

    return {
      filteredNotifications,
      activeCount,
      getSummaryLabel,
      removeJob,
      getStepParams
    };
  },
};
</script>

<style scoped>
.notif-scroll-container {
  max-height: 400px;
  width: 400px;
  overflow-y: auto;
}
</style>